<template>
   <div class="afterzixun-in-2">
     <div class="left">
        <div class="pic">
            <img :src="obj.image">
            <div class="e-info">
                <div class="line-1">{{obj.create_time.slice(5,10)}}</div>
                <div class="line-2">{{obj.create_time.slice(0,4)}}</div>
            </div>
        </div>
        <div class="l-title">{{ obj.title }}</div>
        <div class="l-content xianzhi-line">{{ obj.content }}</div>
        <div class="l-line"></div>
        <div class="more" @click="goDetail(obj.id)">查看更多></div>
        <div class="zhang">IFM Professional Certificate</div>
     </div>
     <div class="right">
        <div class="item-list">
            <div v-for="(item) in arr.slice(0,4)" :key="item.id" class="item" @click="goDetail(item.id)">
                <img style="width: 120px;" :src="item.image">
                <div class="content-blo">
                    <div class="title">{{item.create_time}}</div>
                    <div class="content tt xianzhi-line" style="-webkit-line-clamp: 1">{{ item.title }}</div>
                    <div class="content xianzhi-line" style="-webkit-line-clamp: 2">{{ item.content }}</div>
                </div>
                <div class="arrow"><i class="el-icon-arrow-right"/></div>
            </div>
        </div>
        <div class="view-btn" @click="goList(3)">全部新闻</div>
     </div>
   </div>
</template>
<script>
import myMixin from './mixin';
export default {
   name: '',
   components: {
     
   },
   mixins: [myMixin],
   props: {
     
   },
   data() {
     return {
       arr: [],
       obj: {
         id: '',
         image: '',
         create_time: '',
         title: '',
         content: ''
       },
     }
   },
   computed: {
     
   },
   watch: {
     
   },
   created() {
     this.getDataFunc();
   },
   methods: {
    async getDataFunc(){
        try {
            const res = await this.$http.get('/api/news/information', {
                limit: 10,
                type: 3,
            });
            if(res && res.length){
                this.obj = res[0] || this.obj;
                this.arr = res.slice(1,10);
            }else{
                this.arr = [];
            }
        } catch (error) {
            this.$toast(error.message||'请求失败');
        }
     }
   }
};
</script>
<style lang='scss' scoped>
.afterzixun-in-2{
    width: 1120px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
}
.left{
    width: 440px;
    height: 632px;
    opacity: 1;
    background: #ffffff;
    padding: 47px 0;
    box-sizing: border-box;
    .pic{
        width: 100%;
        height: 240px;
        position: relative;
        img{
            width: 100%;
            height: 100%;
        }
        .e-info{
            position: absolute;
            left: 0px;
            top: 0px;
            width: 77px;
            height: 60px;
            background-color: #234688;
            .line-1{
                color: #ffffff;
                font-size: 18px;
                font-weight: 600;
                font-family: "PingFang HK";
                padding-top: 10px;
                padding-left: 8px;
            }
            .line-2{
                color: #a4ccff;
                text-align: right;
                font-size: 14px;
                font-weight: 400;
                font-family: "PingFang HK";
                padding-top: 0px;
                padding-right: 8px;
            }
        }
    }
    .l-title{
        color: #3d3d3d;
        text-align: left;
        font-size: 16px;
        font-weight: bold;
        font-family: "Roboto";
        line-height: 26px;
        padding: 12px 0 6px 0;
    }
    .l-content{
        color: #888888;
        text-align: left;
        font-size: 14px;
        font-weight: 400;
        font-family: "Roboto";
        line-height: 22px;
    }
    .l-line{
        background-color: #EAEAEA;
        width: 100%;
        height: 1px;
        margin: 6px 0;
    }
    .more{
        color: #234688;
        text-align: left;
        font-size: 14px;
        font-weight: 400;
        font-family: "PingFang SC";
        cursor: pointer;
    }
    .zhang{
        text-align: center;
        color: #f2efe9;
        font-size: 25px;
        font-weight: 700;
        padding-top: 20px;
    }
}
.right{
    width: 640px;
    height: 632px;
    opacity: 1;
    background: #ffffff;
    padding: 50px 0;
    box-sizing: border-box;
    .item-list{
        width: 100%;
        .item{
            display: flex;
            align-items: start;
            height: 100px;
            border-bottom: 1px solid #EAEAEA;
            margin-bottom: 20px;
            img{
                width: 150px !important;
                height: 75px;
                object-fit: cover;
                flex-shrink: 0;
            }
            .content-blo{
                padding-left: 20px;
                flex: 1;
                margin-right: 20px;
                color: #3d3d3d;
                text-align: left;
                font-size: 14px;
                font-weight: 400;
                font-family: "PingFang SC";
                overflow: hidden;
                .content{
                    line-height: 21px;
                }
                .tt{
                    font-weight: bold;
                }
            }
            .arrow{
                font-size: 16px;
                width: 30px;
                margin-top: 26px;
                flex-shrink: 0;
                text-align: right;
            }
        }
    }
    .view-btn{
        width: 156px;
        height: 46px;
        line-height: 46px;
        text-align: center;
        background-color: #234688;
        color: #ffffff;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        font-family: "Microsoft YaHei";
        float: right;
        cursor: pointer;
    }
}
</style>
